import React from "react";
import logoo from "../assets/logo.svg";
import { Link } from "react-router-dom";

function Header({ onOpenAuth, onOpenMenu }) {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Link to="/" className="flex items-center gap-2">
          <img src={logoo} className="w-50 h-10" alt="logo" />
        </Link>

        <div className="hidden flex-1 items-center justify-center px-8 md:flex">
          <div className="flex w-full max-w-xl items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-slate-500">
            <input
              placeholder="Search for something..."
              className="w-full bg-transparent text-xs text-slate-700 focus:outline-none"
            />
            <button className="rounded-full bg-indigo-600 px-4 py-1.5 text-xs font-semibold text-white">
              Search
            </button>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onOpenMenu}
            aria-label="Open menu"
            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M4 7h16" />
              <path d="M4 12h16" />
              <path d="M4 17h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;